import React from "react";
import { formatMoneyInt } from "@/lib/money";
import { useLang } from "@/context/LanguageContext";

// Annual = 12 months −20% (same rule as the backend checkout).
export function planAmounts(monthlyPrice, annual) {
  const total = annual ? Math.round(monthlyPrice * 12 * 0.8) : monthlyPrice;
  const monthly = annual ? total / 12 : monthlyPrice;
  return { total, monthly };
}

export function PlanRecapCard({ name, price, annual }) {
  const { t, lang } = useLang();
  const { total, monthly } = planAmounts(price || 0, annual);
  const fmtMonthly = Number.isInteger(monthly) ? formatMoneyInt(monthly, lang) : formatMoneyInt(Math.round(monthly * 100) / 100, lang);
  return (
    <div className="rounded-xl border border-border bg-slate-50 p-4" data-testid="plan-recap-card">
      <p className="text-xs uppercase tracking-wide font-semibold text-slate-500">{t("hc.selectedPlan")}</p>
      <p className="mt-0.5 text-lg font-bold text-findo-navy" data-testid="plan-recap-name">{name}</p>
      <div className="mt-3 flex items-baseline justify-between gap-3 border-t border-border pt-3">
        <span className="text-sm text-slate-600">{t("hc.monthlyPrice")}</span>
        <span className="text-2xl font-extrabold text-findo-navy shrink-0" data-testid="plan-recap-monthly">
          {fmtMonthly}<span className="text-sm font-semibold text-slate-500"> {t("price.ht")} {t("hc.perMonth")}</span>
        </span>
      </div>
      {annual ? (
        <div className="mt-2 flex items-baseline justify-between gap-3" data-testid="plan-recap-annual">
          <span className="text-sm text-slate-600">{t("hc.annualTotal")} <span className="text-emerald-700 font-semibold">(−20%)</span></span>
          <span className="text-base font-bold text-findo-navy shrink-0" data-testid="plan-recap-annual-total">
            {formatMoneyInt(total, lang)}<span className="text-sm font-semibold text-slate-500"> {t("hc.perYear")}</span>
          </span>
        </div>
      ) : (
        <p className="mt-1 text-xs text-slate-500" data-testid="plan-recap-cycle">{t("hc.monthlyBilling")}</p>
      )}
      <p className="mt-2 text-xs text-slate-500">{annual ? t("hc.billedOnceYear") : t("hc.billedEachMonth")}</p>
    </div>
  );
}
